import { render, staticRenderFns } from "./Products-filter-variations.vue?vue&type=template&id=788b4904&"
import script from "./Products-filter-variations.vue?vue&type=script&lang=js&"
export * from "./Products-filter-variations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports